// Nomenclatura de codigo
// {job.dsforderid}&"-"& {job.ccmasterid}&"-"&  {cartoncontent.jobpart}     &"-"& {shipvia.syshipviaid}&"-"& {report_shippinglabel.cclqtythiscarton}  &"-"& {report_shippingLabel.cclcurrentlabel}&"-"& {report_shippingLabel.ccltotalcartons}&"-"&{jobshipment.ccshipmentid}&"-"&{cartoncontent.id}  
const CARTON_REGEX = /([^-/]*)[-/]([^-/]+)[-/]([^-/]+)?[-/]([^-/]+)[-/]([^-/]+)?[-/]([^-/]+)[-/]?([^-/]*)[-/]?([^-/]*)[-/]?([^-/]*)/
const N8N_ENTREGA_CLIENTE_WEBHOOK_URL = process.env.VUE_APP_N8N_ENTREGA_CLIENTE_WEBHOOK_URL
const SOLTAR_API_URL = process.env.VUE_APP_SOLTAR_API_URL
const VUE_APP_ENV = process.env.VUE_APP_ENV
const ENV = process.env
const EVENT_CARTON_DEVUELTO = 'devuelto'
const EVENT_CARTON_ENTREGADO = 'entregado'
const EVENT_CARTON_EN_ALMACEN = 'en-almacen'
const EVENT_CARTON_GUIA_RELACION = 'guia-relacionado'
const EVENT_CARTON_EN_VEHICULO = 'en-vehiculo'
const EVENT_CARTON_GUIA_ENTREGADA = 'en-paqueteria'
const EVENT_CARTON_PRODUCCION_TERMINADA = 'produccion-terminada'
const EVENT_CARTON_AJUSTADO_POR_INVENTARIO = 'ajustado-por-inventario'
const EVENTS_CARTONS = [
    EVENT_CARTON_DEVUELTO,
    EVENT_CARTON_ENTREGADO,
    EVENT_CARTON_EN_ALMACEN,
    EVENT_CARTON_GUIA_RELACION,
    EVENT_CARTON_EN_VEHICULO,
    EVENT_CARTON_GUIA_ENTREGADA,
    EVENT_CARTON_PRODUCCION_TERMINADA,
    EVENT_CARTON_AJUSTADO_POR_INVENTARIO
]
const UPDATE_CARTONS_FUNCTION_URL = "https://update-cartons-function-423805886578.us-central1.run.app";

export {
    CARTON_REGEX, 
    EVENT_CARTON_DEVUELTO,
    EVENT_CARTON_ENTREGADO,
    EVENT_CARTON_EN_ALMACEN,
    EVENT_CARTON_GUIA_RELACION,
    EVENT_CARTON_EN_VEHICULO,
    EVENT_CARTON_GUIA_ENTREGADA,
    EVENT_CARTON_PRODUCCION_TERMINADA,
    EVENT_CARTON_AJUSTADO_POR_INVENTARIO,
    EVENTS_CARTONS,
    UPDATE_CARTONS_FUNCTION_URL,
    N8N_ENTREGA_CLIENTE_WEBHOOK_URL,
    SOLTAR_API_URL,
    VUE_APP_ENV, ENV
}
